export function workingDays(decoded) {
  let date = new Date(Date.now());
  let daysToAdd = [4, 3, 3, 5, 5, 5, 5];

  let dateVal = daysToAdd[date.getDay()];

  decoded.role !== "procurement" && date.setDate(date.getDate() + dateVal);

  return date;
}
